// extracted by mini-css-extract-plugin
export default {"medium":"only screen and (min-width: 768px)","brandAdContainer":"X0XNX","saveForLater":"TR+M+"};